var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"hero hero--full"},[_c('hero-content',{attrs:{"title":_vm.$helpers.trans('errors.404.title')}},[_c('p',[_vm._v(_vm._s(_vm.$helpers.trans('errors.404.description')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.$helpers.trans('errors.404.label')))])])],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f0fe9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/errors/404.vue
// module id = SjeC
// module chunks = 17